// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1887":"719191ab8a695139","8528":"327bcca24616ea54"}[chunkId] + ".css";
};